import useCameraFleetFlag from '@cobliteam/hooks/src/useCamera/useCameraFleetFlag';
import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { Typography } from '@cobliteam/ui/components';
import Checkbox from '@cobliteam/ui/form/Checkbox';
import Label from '@cobliteam/ui/form/Label';

import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect, useState } from 'react';

const FlagsData = () => {
  const session = useUser().getSession();
  const queryClient = useQueryClient();

  const { getFleetPremiumPackageFlag, FLEET_FLAG_QUERY_KEY: fleetFlagQueryKey } = useCameraFleetFlag();
  const { data: isPremium } = getFleetPremiumPackageFlag();
  const [isPremiumSelected, setIsPremiumSelected] = useState<boolean>(isPremium ?? false);

  const handlePremiumChange = useCallback(
    (checked: boolean | 'indeterminate') => {
      queryClient.setQueryData([fleetFlagQueryKey, session.fleet.id, 'FLEET_PRODUCTS_FLAG'], {
        products: [{ id: '', name: checked ? 'PREMIUM' : 'BASIC' }],
      });
    },
    [queryClient, fleetFlagQueryKey, session.fleet.id]
  );

  useEffect(() => {
    handlePremiumChange(isPremiumSelected);
  }, [isPremiumSelected, handlePremiumChange]);

  return (
    <div className='flex flex-col gap-4'>
      <Typography variant='heading-1'>Flags</Typography>
      <div className='flex items-center gap-2'>
        <Checkbox id='premium' checked={isPremiumSelected} onCheckedChange={handlePremiumChange} />
        <Label htmlFor='premium'>Premium</Label>
      </div>
    </div>
  );
};

export default FlagsData;
